<template>
  <FormInput
    ref="finput"
    :invalid="invalid"
    size="auto"
    focusRef="input"
    v-bind="$attrs"
  >
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
    <template #default="{ focusRef, _inputClasses, api }">
      <div class="relative w-full">
        <Simplebar
          class="w-full max-h-540px relative"
          data-simplebar-auto-hide="false"
        >
          <textarea
            :ref="focusRef"
            :value="value"
            class="w-full bg-transparent outline-none relative z-10 overflow-ellipsis
            overflow-hidden xs:text-sm text-neutral-50"
            :class="_inputClasses"
            :placeholder="placeholder"
            @focus="focusHandler(api)"
            @blur="blurHandler(api)"
            @input="onInput"
          />
        </Simplebar>
        <!-- eslint-disable -->
        <div
          class="absolute left-0 right-0 bottom-0 h-84px pointer-events-none bg-gradient-to-t from-black-01 rounded-5px transition-opacity duration-75"
          :class="{
            'opacity-0': !showShadow,
            'opacity-100': showShadow,
          }"
        />
        <!-- eslint-enable -->
      </div>
    </template>
  </FormInput>
</template>

<script>
import FormInput from '@/components/Form/FormInput.vue';
import Simplebar from '@/components/Global/Simplebar.vue';

export default {
  name: 'FormTextarea',
  components: {
    FormInput,
    Simplebar,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showShadow: false,
    };
  },
  computed: {
    input() {
      return this.$refs.finput?.$el;
    },
    el() {
      return this.$refs.input;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.el) {
        this.resize({ target: this.el });
      }
    });
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
      this.resize(event);
    },
    resize({ target }) {
      // eslint-disable-next-line no-param-reassign
      target.style.height = '1px';
      // eslint-disable-next-line no-param-reassign
      target.style.height = `${target.scrollHeight}px`;
    },
    focusHandler(api) {
      api.focus();
      this.$emit('focus');
    },
    blurHandler(api) {
      api.blur();
      this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped>
textarea {
  resize: none;
}
::v-deep {
  .simplebar-track {
    &.simplebar-vertical {
      @apply -right-4;
    }
  }
}
</style>
